export const LD_GLOBAL_CONFIG = { kind: "device", key: "global", type: "web" };
